import { FormFieldsStrategyType, QuotesType } from "@/common/types";
import diaQuoteLineStrategy from "./diaQuoteLine.strategy";
import biaQuoteLineFormStrategy from "./biaQuoteLineForm.strategy";
import wiaQuoteLineFormStrategy from "./wiaQuoteLineForm.strategy";
import ipAddressQuoteLineFormStrategy from "./ipAddressQuoteLineForm.strategy";
import eplQuoteLineFormStrategy from "./eplQuoteLineForm.strategy";
import hardwareQuoteLineFormStrategy from "./hardwareQuoteLineForm.strategy";
import fieldServiceQuoteLineFormStrategy from "./fieldServiceQuoteLineForm.strategy";
import rackAndSpaceQuoteLineFormStrategy from "./rackAndSpaceQuoteLineForm.strategy";
import crossConnectQuoteLineFormStrategy from "./crossConnectQuoteLineForm.strategy";
import { QUOTES_TYPE } from "@/common/const/types/index.const";

const vendorQuoteLineStrategy: Record<QuotesType, FormFieldsStrategyType[]> = {
  [QUOTES_TYPE[0]]: diaQuoteLineStrategy,
  [QUOTES_TYPE[1]]: diaQuoteLineStrategy,
  [QUOTES_TYPE[2]]: biaQuoteLineFormStrategy,
  [QUOTES_TYPE[3]]: wiaQuoteLineFormStrategy,
  [QUOTES_TYPE[4]]: ipAddressQuoteLineFormStrategy,
  [QUOTES_TYPE[5]]: eplQuoteLineFormStrategy,
  [QUOTES_TYPE[6]]: eplQuoteLineFormStrategy,
  [QUOTES_TYPE[7]]: hardwareQuoteLineFormStrategy,
  [QUOTES_TYPE[8]]: fieldServiceQuoteLineFormStrategy,
  [QUOTES_TYPE[9]]: rackAndSpaceQuoteLineFormStrategy,
  [QUOTES_TYPE[10]]: crossConnectQuoteLineFormStrategy,
};
export default vendorQuoteLineStrategy;
